<!-- 会员卡 -->
<template>
   <div class="page_content">
      <!-- <subComponents ref="showSelectData"></subComponents> -->
      <el-dialog :visible.sync="showStatus" :title="actionData.cate === 0 ? '新增' : '编辑'" width="65%" :modal-append-to-body="true" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="true"
                 center>
         <getKeyQueryModal v-if="showStatus" ref="storeMastRef" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></getKeyQueryModal>
      </el-dialog>

      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" :buttonFlag="false" @openFormDesign="openFormDesign"></v-button>
         <div class="page_content_top_line">
            <v-search :searchList="searchList" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch"></v-search>
         </div>
      </div>
      <div style="display: flex; just-content: space-between">
         <div class="page_content_center" style="width: 100%">
            <el-table :key="tableFlag" stripe @selection-change="handleSelectionChange" @row-click="storePeopleClick" :data="returnData.list" :height="tableHeight" border style="width: 100%" highlight-current-row
                      size="mini">
               <!-- 主信息 -->

               <el-table-column header-align="center" label="选择操作" width="80">
                  <template slot-scope="scope">
                     <el-radio v-model="selectedRowIndex" :label="scope.$index" border size="mini" @change="handleRadioChange(scope.row, scope.$index)">
                        <i class="el-icon-thumb"></i>
                     </el-radio>
                  </template>
               </el-table-column>
               <el-table-column v-for="(tableValye, tableKey) in pageShowData" :key="tableKey" align="center" :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip
                                :min-width="tableValye.fieldWeight" :fixed="tableValye.fixed || false">
                  <template slot-scope="scope">
                     <span v-if="tableValye.fieldType == 'date'">
                        <span v-if="scope.row[tableValye.entityField]">
                           {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                        </span>
                     </span>
                     <el-tag size="mini" v-if="tableValye.entityField == 'state'" >
                        {{ scope.row[tableValye.entityField] == 1?'启用':'禁用' }}
                     </el-tag>
                     <span v-else>
                        {{ scope.row[tableValye.entityField] }}
                     </span>
                  </template>
               </el-table-column>
            </el-table>
         </div>
      </div>

      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" :parentSearchData="parentSearchData" />
      </el-dialog>
      <customDesign ref="customDesign"></customDesign>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import SearchScheme from "../../../byComponents/SearchScheme.vue"
// 会员卡类型新增/编辑组件
import getKeyQueryModal from "./getKeyQueryModal.vue"
import { nameList } from "./getKeyQuery.js"

export default {
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
      getKeyQueryModal,
   },
   data() {
      //这里存放数据
      return {
         sField: "",
         exTitle: "",
         exWidth: "",
         searchList: [],
         getRequestData: {
         },
         //---------------
         seTitle: "",
         DialogVisible: false,
         seId: "",
         setField: "",
         setType: "",
         seWidth: "0",
         parentSearchData: {},
         //---------------
         returnData: {
            pages: 0, // 总页数
            total: 0, // 总条数
            pageNum: 0, // 当前页数
            list: [],
         },
         buttonList: [],
         multipleSelection: [],
         pageShowData: {},
         tableFlag: 0,
         selectedDataIndex: 0,
         id: "",
         tableHeight: 0,
         showStatus: false,
         actionData: {},
         selectedRowIndex: -1,
      }
   },
   //方法集合
   methods: {
      // 子组件触发
      drawerCancel(e) {
         console.log(e, "+++++++++")
         this.showStatus = false
         this.getDataList()
      },
      // 点击穿透字段 传参单号
      toDetail(orderId) {
          if (orderId) {
             // 设置为true 打开穿透组件首页
             var isPenetrate = true
             // 设置缓存 存入点击单号
             this.resetSetItem('penetrateOrderId', orderId);
             // 与父级跨域通信 传递isPenetrate参数
             window.parent.postMessage({  //向窗口发送MessageEvent消息
                cmd: 'returnFormJson',
                params: { isPenetrate } //参数
             }, '*');
          }
         this.getPageInfo()
      },
      openFormDesign() {
         let pathInfo = parent.getMenuInfo(this.$route.path)

         this.$refs["customDesign"].openBox(
            pathInfo.jurId,
            this.pageShowData,
            pathInfo.jurName
         )
      },
      storePeopleClick(row) {
         this.id = row.id
         this.selectedRowIndex = this.returnData.list.findIndex(
            (item) => item.id === row.id
         )
      },

      // 检索Id, 索引(表格中), 标识
      openSearch(val) {
         this.setType = val.type
         this.seId = val.sId
         this.setField = val.sField
         this.parentSearchData[this.setType] = this.getRequestData[this.setType]
         if (this.setType == "salesName") {
            this.parentSearchData.opmSalesperson = 1
         }
         this.DialogVisible = true
      },

      // 赋值字段
      paramValue(val) {
         let arr = this.setField.split(",")
         arr.forEach((item) => {
            this.getRequestData[item] = val[item]
         })
      },
      //检索方案返回的数据
      changeInputModel(val) {
         if (val) {
            if (this.setType == "salesName") {
               this.getRequestData.salesName = val.opmName
               this.getRequestData.salesId = val.opmId
            } else {
               this.paramValue(val)
            }
         }
         this.DialogVisible = false
      },

      handleSelectionChange(val) {
         this.multipleSelection = val
      },

      // 勾选明细
      handleSelectionChange(val) {
         console.log(val, "+++++++++")
         this.multipleSelection = val
      },

      getSeWidth(e) {
         console.log(e)
         this.seWidth = e + "%"
      },
      getWidth(e) {
         console.log(e)
         this.exWidth = e + "%"
      },
      getSearchName(e) {
         console.log(e)
         this.seTitle = e
      },

      // 获取数据列表
      async getPageInfo() {
         this.pageShowData = JSON.parse(JSON.stringify(nameList))
         let res = await this.$http.cashdeskGetKeyList(this.getRequestData)
         if (res.status == 200) {
            this.returnData.list = res.result
            this.selectedDataIndex = 0
            // 默认选中第一条数据
            if (this.returnData.list.length > 0) {
               this.selectedRowIndex = 0
               this.id = this.returnData.list[0].id
            }
         } else {
            this.$message({
               message: res.message,
               type: "error",
            })
         }
      },
      // 动作集合
      async actionSet(actionData) {
         console.log(actionData.actionType)
         switch (actionData.actionType) {
            case 0:
               this.showStatus = true
               this.actionData = {
                  cate: 0,
                  formData: [],
                  oldData: "",
               }
               break
            case 1:
               if (this.selectedRowIndex < 0) {
                  this.$message({
                     message: "请先选中要操作的数据",
                     type: "error",
                  })
                  return false
               }
               this.showStatus = true
               this.actionData = {
                  cate: 1,
                  formData: [],
                  oldData: this.returnData.list[this.selectedRowIndex],
               }
               break
         }
      },

      // 数据搜索
      searchData() {
         this.getRequestData.page = 1
         this.getDataList()
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val
         this.getDataList()
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1
         this.getRequestData.rows = val
         this.getDataList()
      },

      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.cashdeskGetKeyList(
            this.getRequestData
         )
         if (responseData.status == 200) {
            this.returnData.list = responseData.result
            this.selectedDataIndex = 0
            // 默认选中第一条数据
            if (this.returnData.list.length > 0) {
               this.selectedRowIndex = 0
               this.id = this.returnData.list[0].id
            }
            this.$nextTick(() => {
               this.tableHeight = this.$common.getTableHeight()
               this.tableFlag++
            })
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            })
         }
      },

    

      async getButtonList() {
         this.buttonList = await this.$common.getActionButton()

      },
      handleRadioChange(row, index) {
         this.selectedRowIndex = index
         this.id = row.id
      },
      // 触发组件的提交
      fileSuccess(val) {
      },
      // 关闭弹窗
      closeExcel(refresh) {
         this.UploadVisible = false
         if (refresh) this.getDataList();
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getPageInfo()
      this.getButtonList()
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {
      this.$nextTick(() => {
         this.tableHeight = this.$common.getTableHeight()
         this.tableFlag++
      })
   },
   updated() {
      this.$nextTick(() => {
         this.tableHeight = this.$common.getTableHeight()
      })
   }, //生命周期 - 更新之后
}
</script>
<style scoped>
.table_content_tag {
   margin-right: 1rem;
}

.el-tabs--border-card_new {
   height: 85vh;
   overflow-y: scroll;
}

.btns {
   display: flex;
   position: absolute;
   z-index: 999;
   padding-left: 10px;
   padding-top: 2px;
}

::v-deep.xunjia tr {
   height: 39px !important;
}

::v-deep.xunjia .el-button {
   font-size: 12px;
   padding: 5px 10px;
}

::v-deep.xunjia .el-button--danger {
   color: #fff;
   background-color: #f56c6c;
   border-color: #f56c6c;
}

::v-deep.xunjia .el-button--danger:hover {
   color: #fff;
   background-color: #f78989;
   border-color: #f78989;
}

::v-deep.xunjia .el-table__fixed-right {
   height: 100% !important;
   position: absolute;
   top: 0;
   overflow: hidden;
   background-color: #fff;
   z-index: 3;
}

::v-deep.xunjia .el-table__fixed-right-patch {
   background-color: #fff;
}
</style>
